import e, { useMemo as y } from "react";
import { useTranslation as x } from "react-i18next";
import T from "classnames";
import { CheerfyFont as f } from "../CheerfyFont/CheerfyFont.js";
import { TicketStatus as u, TicketFeeType as S } from "../../../api/models/ticket/ticket.types.js";
import { getTicketStatusKey as C } from "../../../api/models/ticket/utils.js";
import { getDateTime as b, formatCurrency as m } from "../../../../utils.js";
import a from "./ticket.module.scss.js";
function w({
  ticket: t,
  preHeader: _,
  follow: s,
  colors: i,
  options: d
}) {
  const {
    t: c
  } = x(), E = y(() => [
    ...t.ticketItemList.reverse(),
    ...t.ticketComboList.reverse()
  ], [t.id]), { currency: r } = t.ticketSummary, v = (d == null ? void 0 : d.showHeader) ?? !0, p = s && t.status !== u.COMPLETED && t.status !== u.CANCELLED;
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      "data-testid": "ticket",
      className: a.ticket,
      style: {
        "--borderColor": (i == null ? void 0 : i.borderColor) ?? "#DDD"
      }
    },
    v && /* @__PURE__ */ e.createElement("div", { className: a.ticket__header }, /* @__PURE__ */ e.createElement("div", { className: a.ticket__preHeaderWrapper }, _, /* @__PURE__ */ e.createElement("div", { className: a.ticket__heading }, /* @__PURE__ */ e.createElement("div", null, "#", t.ticketNumber ?? t.id), !!t.ticketService && /* @__PURE__ */ e.createElement(f, { icon: t.ticketService.getServiceKey() }))), /* @__PURE__ */ e.createElement("div", { className: a.ticket__context }, /* @__PURE__ */ e.createElement("div", { className: a.ticket__context__scope }, t.scope.location.name)), p && /* @__PURE__ */ e.createElement(
      "a",
      {
        href: s.getFollowUrl(t.ticketId),
        target: "_blank",
        className: a.ticket__followBtn,
        style: {
          backgroundColor: s.backgroundColor,
          color: s.textColor
        },
        rel: "noreferrer"
      },
      c("ticket.followOrderBtn")
    ), /* @__PURE__ */ e.createElement("div", { className: a.ticket__timeContext }, /* @__PURE__ */ e.createElement("div", null, c(C(t.status))), /* @__PURE__ */ e.createElement("div", null, c("ticket.placed"), " ", b(t.created)))),
    /* @__PURE__ */ e.createElement("div", { className: a.ticket__productList }, E.map((l, o) => {
      const k = l.items ?? l.modifiers ?? [];
      return /* @__PURE__ */ e.createElement("div", { key: `${l.itemId}-${o}`, className: a.ticket__product }, /* @__PURE__ */ e.createElement("div", { className: a.ticket__product__quantity }, l.quantity, "x"), /* @__PURE__ */ e.createElement("div", { className: a.ticket__product__summary }, /* @__PURE__ */ e.createElement("div", null, l.name), l.combo && /* @__PURE__ */ e.createElement("div", { className: a.ticket__product__small }, l.combo), l.description && /* @__PURE__ */ e.createElement("div", { className: a.ticket__product__small }, l.description), l.notes && /* @__PURE__ */ e.createElement("div", { className: a.ticket__product__small }, l.notes), k.map((n, N) => /* @__PURE__ */ e.createElement(
        "div",
        {
          key: `${n.itemId}-${N}`,
          className: T({
            [a.ticket__product__modifier]: !0,
            [a.ticket__product__small]: !0
          })
        },
        /* @__PURE__ */ e.createElement("div", { className: a.ticket__product__quantity }, n.quantity, "x"),
        /* @__PURE__ */ e.createElement("div", { className: a.ticket__product__summary }, /* @__PURE__ */ e.createElement("div", null, l.name), /* @__PURE__ */ e.createElement("span", null, c(n.subtotal ? "subtotal" : "total"), ": "), /* @__PURE__ */ e.createElement("span", null, m(
          (n.subtotal || n.total) / 100 || 0,
          r
        )))
      ))), /* @__PURE__ */ e.createElement("div", { className: a.ticket__product__price }, m(l.total / 100, r)));
    })),
    /* @__PURE__ */ e.createElement("div", { className: a.ticket__summary }, /* @__PURE__ */ e.createElement("div", { className: a.ticket__tuple }, /* @__PURE__ */ e.createElement("div", null, c("subtotal")), /* @__PURE__ */ e.createElement("div", null, m(t.ticketSummary.subtotal / 100, r))), t.ticketSummary.tip > 0 && /* @__PURE__ */ e.createElement("div", { className: a.ticket__tuple }, /* @__PURE__ */ e.createElement("div", null, c("tip")), /* @__PURE__ */ e.createElement("div", null, m(t.ticketSummary.tip / 100, r))), t.ticketSummary.discountAmount > 0 && /* @__PURE__ */ e.createElement("div", { className: a.ticket__tuple }, /* @__PURE__ */ e.createElement("div", null, c("discount")), /* @__PURE__ */ e.createElement("div", null, "-", m(t.ticketSummary.discountAmount / 100, r))), t.ticketFees.filter((l) => l.amount > 0).map((l, o) => /* @__PURE__ */ e.createElement(
      "div",
      {
        className: `${a.ticket__tuple} ${l.voided ? a["ticket__tuple--voided"] : ""}`,
        key: o
      },
      /* @__PURE__ */ e.createElement("div", null, l.feeType === S.DELIVERY ? c("deliveryFee") : l.name || c("defaultFeeName")),
      /* @__PURE__ */ e.createElement("div", null, m(l.amount / 100, r))
    )), !t.ticketSummary.taxInPrices && t.ticketTaxes.length > 0 && /* @__PURE__ */ e.createElement("div", { className: a.ticket__tuple }, /* @__PURE__ */ e.createElement("div", null, t.ticketTaxes[0].name, "(", t.ticketTaxes[0].rate / 100, "%)"), /* @__PURE__ */ e.createElement("div", null, m(t.ticketTaxes[0].amount / 100, r)))),
    /* @__PURE__ */ e.createElement("div", { className: `${a.ticket__tuple} ${a.ticket__total}` }, /* @__PURE__ */ e.createElement("div", null, c("total")), /* @__PURE__ */ e.createElement("div", null, m(t.ticketSummary.total / 100, r))),
    t.ticketSummary.taxInPrices && t.ticketTaxes.length > 0 && /* @__PURE__ */ e.createElement("div", { className: a.ticket__total__summary }, /* @__PURE__ */ e.createElement("div", { className: a.ticket__tuple }, /* @__PURE__ */ e.createElement("div", null, t.ticketTaxes[0].name, "(", t.ticketTaxes[0].rate / 100, "%)"), /* @__PURE__ */ e.createElement("div", null, m(t.ticketTaxes[0].amount / 100, r))))
  );
}
export {
  w as Ticket
};
//# sourceMappingURL=Ticket.js.map
